import React from "react";
import { Text, Span, Heading } from "@catchoftheday/cg-components";

type UnlinkedContentProps = {
  email?: string;
};

export const UnlinkedContent: React.FC<UnlinkedContentProps> = ({ email }) => {
  return (
    <>
      <Heading.h3
        fontFamily="onePass"
        fontWeight="bold"
        color="onePass.textPrimary"
        m="0px"
      >
        Link OnePass
      </Heading.h3>
      <Text
        fontSize="base"
        fontWeight="medium"
        my="24px"
        fontFamily="onePass"
        color="onePass.textPrimary"
      >
        We will link your OnePass and Catch accounts so you can access your
        member benefits at Catch. You are currently logged in at Catch with{" "}
        <Span fontWeight="bold">{email}</Span>
      </Text>
      <Text
        fontSize="xs"
        fontWeight="medium"
        mb="32px"
        fontFamily="onePass"
        color="onePass.textPrimary"
      >
        OnePass and the participating brands collect your purchasing and
        browsing history from each other and may provide you with personalised
        communications and advertising.
      </Text>
    </>
  );
};
